<template>
    <div>
        <a
            :href="post.URL"
            :title="post.title">
            <div class="thumbnail">
                <div v-if="showImage" class="fill">
                    <div class="img-container">
                        <img
                            v-if="post.featured_image"
                            :src="post.featured_image"
                            :alt="post.title"
                            class="center-block">
                    </div>
                </div>
                <div class="caption">
                    <h4 v-html="post.title"/>
                    <div><strong>{{ post.dateForHumans }}</strong></div>
                    <v-clamp :max-lines="3">
                        {{post.excerpt}}
                    </v-clamp>
                    <div class="read-more">
                        Read more...
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<style scoped>
    .read-more {
        margin-top: 5px;
        color: #403e38;
        font-size: 14px;
    }

    .fill {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden
    }

    .fill .img-container {
        height: 240px;
        overflow: hidden;
    }

    .fill img {
        flex-shrink: 0;
        width: 100%;
        min-height: 240px;
    }

    .thumbnail .caption {
        font-size: larger;
        height: 200px;
        overflow: hidden;
    }

    a {
        text-decoration: none;
        color: black;
    }
</style>

<script>
    import axios from 'axios'
    import {jrNotifyEx} from '../bootstrap'
    import VClamp from 'vue-clamp'

    export default {
        components: {
            VClamp ,
        },

        props: {
            slug: {
                type: String,
                default: null,
            },
            showImage: {
                type: Boolean,
                default: true,
            },
        },

        data () {
            return {
                post: {}
            }
        },

        async created () {
            this.loadPost()
        },

        methods: {
            async loadPost () {
                try {
                    const response = await axios.get("/blog/post/" + this.slug)
                    this.post = response.data.data[0]
                } catch (e) {
                    jrNotifyEx(e)
                }
            },
        }
    }
</script>
